import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

export function OrientationShiftInfoCard() {
  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="success"
      title="This is an Orientation Shift"
      description="Complete this shift to unlock access to future shifts at the workplace"
      illustrationType="document-approved"
    />
  );
}
